(function () {
if (window.customElements && customElements.get('df-dimensions')) return;
var KEY = 'dfDimsUnit';
function readUnit() { try { return localStorage.getItem(KEY) === 'in' ? 'in' : 'cm'; } catch (e) { return 'cm'; } }
function saveUnit(u) { try { localStorage.setItem(KEY, u); } catch (e) {} }
function fmt(v, unit) {
if (unit === 'in') { var i = Math.round((v / 2.54) * 10) / 10; return (i % 1 === 0 ? i.toFixed(0) : i.toFixed(1)); }
var c = Math.round(v * 10) / 10; return (c % 1 === 0 ? c.toFixed(0) : c.toFixed(1));
}
var mobile = window.matchMedia('(max-width: 749px)');
class DfDimensions extends HTMLElement {
connectedCallback() {
var self = this;
this.card = this.querySelector('[data-df-dims-card]');
this.holder = this.querySelector('[data-df-dims-holder]');
this.overlay = this.querySelector('[data-df-dims-overlay]');
this.querySelectorAll('[data-df-dims-unit]').forEach(function (b) {
b.addEventListener('click', function () { DfDimensions.setUnit(b.getAttribute('data-df-dims-unit')); });
});
var tabs = Array.prototype.slice.call(this.querySelectorAll('[data-df-dims-tab]'));
tabs.forEach(function (t, idx) {
t.addEventListener('click', function () { self.showView(t.getAttribute('data-df-dims-tab')); });
t.addEventListener('keydown', function (e) {
if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
var n = tabs[(idx + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
n.focus(); self.showView(n.getAttribute('data-df-dims-tab'));
});
});
this.querySelectorAll('[data-df-dims-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeSheet(); }); });
if (this.overlay) this.overlay.addEventListener('click', function () { self.closeSheet(); });
this.onKey = function (e) { if (e.key === 'Escape') self.closeSheet(); };
var json = this.querySelector('[data-df-dims-variants]');
if (json) {
try { this.variants = JSON.parse(json.textContent); } catch (e) { this.variants = null; }
this.onVariant = function (e) {
var id = (e && e.detail && (e.detail.variant && e.detail.variant.id)) || (e && e.target && e.target.name === 'id' && e.target.value);
if (!id) { var inp = document.querySelector('form[action*="/cart/add"] [name="id"]'); id = inp && inp.value; }
if (id) self.applyVariant(String(id));
};
document.addEventListener('on:variant:change', this.onVariant);
document.addEventListener('variant:change', this.onVariant);
document.addEventListener('dfp:variant', this.onVariant);
document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') self.onVariant(e); });
}
DfDimensions.apply(this, readUnit());
var tpl = this.querySelector('template[data-df-dims-button]');
if (tpl) {
var summary = this.querySelector('.df-dims__summary');
this.placeButton = function () {
if (document.querySelector('[data-df-dims-open]')) return;
var buy = document.querySelector('.dfp-buybox .dfp-delivery') || document.querySelector('.dfp-buybox .dfp-buy');
if (buy) { buy.insertAdjacentElement('afterend', self.rowlink(tpl, summary)); return; }
var form = document.querySelector('.product-form form.js-product-form') || document.querySelector('main form[action*="/cart/add"]');
if (!form) return;
var row = form.closest('.input-row') || form;
var node = tpl.content.firstElementChild.cloneNode(true);
var sub = node.querySelector('[data-df-dims-sub]');
if (sub && summary) sub.textContent = summary.textContent.replace(/\s+/g, ' ').trim();
row.insertAdjacentElement('afterend', node);
};
this.placeButton();
document.addEventListener('on:variant:change', function () { setTimeout(self.placeButton, 100); });
}
}
rowlink(tpl, summary) {
var src = tpl.content.querySelector('[data-df-dims-open]'), svgs = src.querySelectorAll('svg');
var b = document.createElement('button');
b.type = 'button'; b.className = 'dfp-module dfp-rowlink df-dims-rowlink'; b.setAttribute('data-df-dims-open', '');
b.innerHTML = '<span class="dfp-rowlink__icon"></span><span class="dfp-rowlink__text"><strong></strong><span></span></span><span class="dfp-rowlink__chev"></span>';
var t = src.querySelector('.df-dims-trigger__title');
b.querySelector('strong').textContent = t ? t.textContent : 'Dimensions';
b.querySelector('.dfp-rowlink__text span').textContent = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : '';
[['.dfp-rowlink__icon', svgs[0]], ['.dfp-rowlink__chev', svgs[1]]].forEach(function (p) {
if (!p[1]) return;
var s = p[1].cloneNode(true);
['style', 'width', 'height'].forEach(function (a) { s.removeAttribute(a); });
s.setAttribute('class', 'dfp-icon'); s.setAttribute('focusable', 'false');
b.querySelector(p[0]).appendChild(s);
});
return b;
}
showView(name) {
this.querySelectorAll('[data-df-dims-tab]').forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-df-dims-tab') === name ? 'true' : 'false'); });
this.querySelectorAll('[data-df-dims-view]').forEach(function (v) { v.hidden = v.getAttribute('data-df-dims-view') !== name; });
}
open() {
if (mobile.matches) { this.openSheet(); return; }
this.card.scrollIntoView({ behavior: 'smooth', block: 'start' });
var card = this.card; setTimeout(function () { card.focus({ preventScroll: true }); }, 400);
}
openSheet() {
this.holder.style.minHeight = this.holder.offsetHeight + 'px';
this.classList.add('is-sheet');
if (this.overlay) this.overlay.hidden = false;
document.documentElement.style.overflow = 'hidden';
document.addEventListener('keydown', this.onKey);
var close = this.querySelector('[data-df-dims-close]'); if (close) close.focus();
}
closeSheet() {
if (!this.classList.contains('is-sheet')) return;
this.classList.remove('is-sheet');
this.holder.style.minHeight = '';
if (this.overlay) this.overlay.hidden = true;
document.documentElement.style.overflow = '';
document.removeEventListener('keydown', this.onKey);
if (this.lastTrigger) this.lastTrigger.focus();
}
applyVariant(id) {
if (!this.variants || !this.variants[id]) return;
var data = this.variants[id], self = this;
Object.keys(data).forEach(function (k) {
var v = data[k];
self.querySelectorAll('[data-dim-row="' + k + '"]').forEach(function (r) { r.hidden = v === null; });
self.querySelectorAll('[data-dim-g="' + k + '"]').forEach(function (g) { g.style.display = v === null ? 'none' : ''; });
self.querySelectorAll('[data-dim-key="' + k + '"]').forEach(function (el) {
if (v === null) return;
if (el.hasAttribute('data-text')) { el.textContent = v; }
else if (el.hasAttribute('data-fixed')) { el.textContent = fmt(v, 'cm') + ' kg'; }
else { el.setAttribute('data-cm', v); }
});
});
DfDimensions.apply(this, readUnit());
}
static apply(root, unit) {
root.querySelectorAll('[data-df-dims-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-df-dims-unit') === unit ? 'true' : 'false'); });
root.querySelectorAll('[data-cm]').forEach(function (el) {
var v = parseFloat(el.getAttribute('data-cm')); if (isNaN(v)) return;
var max = el.hasAttribute('data-cm-max') ? parseFloat(el.getAttribute('data-cm-max')) : NaN;
var txt = fmt(v, unit) + (isNaN(max) ? '' : '–' + fmt(max, unit));
if (!el.hasAttribute('data-bare')) txt += unit === 'in' ? '"' : ' cm';
el.textContent = txt;
});
root.querySelectorAll('[data-df-unit-word]').forEach(function (el) { el.textContent = unit === 'in' ? 'in' : 'cm'; });
}
static setUnit(u) {
saveUnit(u);
document.querySelectorAll('df-dimensions').forEach(function (el) { DfDimensions.apply(el, u); });
}
}
customElements.define('df-dimensions', DfDimensions); (function (P) { var oOpen = P.openSheet, oClose = P.closeSheet, EZ = 'cubic-bezier(.2,.8,.2,1)'; var rm = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }; P.openSheet = function () { oOpen.call(this); var c = this.card, o = this.overlay; if (!c) return; c.scrollTop = 0; if (!this._dfDrag) { this._dfDrag = true; dfDrag(this); } if (rm()) return; c.style.transition = 'none'; c.style.transform = 'translateY(100%)'; if (o) { o.style.transition = 'none'; o.style.opacity = '0'; } void c.offsetHeight; c.style.transition = 'transform .38s ' + EZ; c.style.transform = 'translateY(0)'; if (o) { o.style.transition = 'opacity .3s ease'; o.style.opacity = '1'; } }; P.closeSheet = function () { if (!this.classList.contains('is-sheet') || this._dfClosing) return; var self = this, c = this.card, o = this.overlay; var done = function () { self._dfClosing = false; if (c) { c.style.transition = ''; c.style.transform = ''; } if (o) { o.style.transition = ''; o.style.opacity = ''; } oClose.call(self); }; if (rm() || !c) { done(); return; } this._dfClosing = true; c.style.transition = 'transform .3s ' + EZ; c.style.transform = 'translateY(100%)'; if (o) { o.style.transition = 'opacity .3s ease'; o.style.opacity = '0'; } setTimeout(done, 300); }; function dfDrag(el) { var c = el.card, o = el.overlay, y0 = 0, dy = 0, t0 = 0, track = false, drag = false, bar = false; c.addEventListener('touchstart', function (e) { if (!el.classList.contains('is-sheet') || el._dfClosing || e.touches.length !== 1) return; track = true; drag = false; dy = 0; y0 = e.touches[0].clientY; bar = !!(e.target.closest && e.target.closest('.df-dims__sheetbar')); }, { passive: true }); c.addEventListener('touchmove', function (e) { if (!track) return; var d = e.touches[0].clientY - y0; if (!drag) { if (d > 6 && (bar || c.scrollTop <= 0)) { drag = true; y0 = e.touches[0].clientY; d = 0; t0 = Date.now(); c.style.transition = 'none'; if (o) o.style.transition = 'none'; } else if (Math.abs(d) > 6) { track = false; return; } else { return; } } dy = Math.max(0, d); if (e.cancelable) e.preventDefault(); c.style.transform = 'translateY(' + dy + 'px)'; if (o) o.style.opacity = String(Math.max(0, 1 - dy / (c.offsetHeight || 600))); }, { passive: false }); var end = function () { if (!track) return; track = false; if (!drag) return; drag = false; var v = dy / Math.max(1, Date.now() - t0); if (dy > 110 || (v > 0.5 && dy > 30)) { el.closeSheet(); } else { c.style.transition = 'transform .25s ' + EZ; c.style.transform = 'translateY(0)'; if (o) { o.style.transition = 'opacity .25s ease'; o.style.opacity = '1'; } } }; c.addEventListener('touchend', end); c.addEventListener('touchcancel', end); } })(DfDimensions.prototype);
document.addEventListener('click', function (e) {
var t = e.target.closest && e.target.closest('[data-df-dims-open]');
if (!t) return;
var el = document.querySelector('df-dimensions');
if (!el) return;
e.preventDefault();
el.lastTrigger = t;
el.open();
});
})();